import { useCallback } from 'react';

import { useChatik } from '@hh.ru/chatik-integration';

interface UseSupportChatikType {
    dataQa: string;
    handleChatikClick: () => void;
}

type UseSupportChatikFunction = (onClick?: () => void) => UseSupportChatikType;

const useSupportChatik: UseSupportChatikFunction = (onClick) => {
    const { openChatik } = useChatik();
    const dataQa = 'support-chat-button';

    const handleChatikClick = useCallback(() => {
        openChatik({ chatId: 'support', view: 'compact', hhtmFromLabel: 'clickme_chat_list' });
        onClick?.();
    }, [openChatik, onClick]);

    return { dataQa, handleChatikClick };
};

export default useSupportChatik;
